import Store from 'store/store'
import { Component } from 'utils/jsx'
import { derived } from 'utils/state'

import moment from 'moment'
import classnames from 'classnames'

import Event from 'components/Event'
import Modal from 'components/Modal'

export default class User extends Component {
  beforeRender (props) {
    this.state = {
      isCurrentUser: derived(Store.ip, ip => ip === props.name)
    }
  }

  template (props) {
    return (
      <div class='user' store-class-is-current-user={this.state.isCurrentUser}>
        <div class='user__events' ref={this.ref('events')} />
      </div>
    )
  }

  afterRender (props) {
    for (const event of props.events) {
      this.render((
        <Event
          event-click={this.handleEventClick(event).bind(this)}
          moment={moment(event.date)}
          action={event.action}
          data={event.data}
        />
      ), this.refs.events)
    }
  }

  handleEventClick (clickedEvent) {
    return function (e) {
      this.render((
        <Modal title={`${this._parent.state.title}\nuser: ${this.props.name}`} ref={this.ref('modal')}>
          <table>
            <tr>
              <th>heure</th>
              <th>action</th>
              <th>data</th>
            </tr>

            {this.props.events.map(event => (
              <tr class={classnames({ 'is-active': event === clickedEvent })}>
                <td>{moment(event.date).format('HH:mm')}</td>
                <td>{event.action}</td>
                <td>
                  <pre>
                    {
                      JSON.stringify(event.data, null, Object.entries(event.data).length > 1 ? 2 : 0)
                    }
                  </pre>
                </td>
              </tr>
            ))}
          </table>
        </Modal>
      ), document.body)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/User.js